import React from 'react'

const LoginLoader = () => {
  return (
    <div className='w-full z-50 absolute inset-0 h-screen overflow-hidden  flex flex-col gap-4 justify-center items-center bg-black/60 backdrop-blur-[20px]'>
        <div className='w-12 h-12 md:w-16 md:h-16 rounded-full border-4 border-[#2BBD13] border-t-transparent animate-spin' />
        <div className='mt-2 font-semibold text-[16px] md:text-[24px] text-white'>Setting things up for you…</div>
    </div>
  )
}

export default LoginLoader